<div class="row">
  <div class="col-md-6 col-sm-6">
    <app-average [data]="averageProfit"></app-average>
  </div>
  <div class="col-md-6 col-sm-6">
    <app-average [data]="averageSales"></app-average>
  </div>
</div>
